<template>
  <div>
    <AppointText :appoint="appoint"></AppointText>
    <p class="title">来访者信息</p>
    <table class="c-talbe">
      <tr>
        <td class="text-right" width="150">姓名</td>
        <td v-if="appoint.student">{{ appoint.student.studentName }}</td>
      </tr>
      <tr>
        <td class="text-right" width="150">学号</td>
        <td v-if="appoint.student">{{ appoint.student.studentNo }}</td>
      </tr>
      <tr>
        <td class="text-right">学院</td>
        <td v-if="appoint.student">{{ appoint.student.studentCollege }}</td>
      </tr>
      <tr>
        <td class="text-right">专业</td>
        <td v-if="appoint.student">{{ appoint.student.studentMajor }}</td>
      </tr>
      <tr>
        <td class="text-right">联系方式</td>
        <td v-if="appoint.student">{{ appoint.student.loginPhone }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import AppointText from '@/components/appointText'
export default {
  components: {
    AppointText,
  },  
  props: {
    appoint: {},
  },   
};
</script>
<style scoped>
.title {
  width: 100%;
  padding: 10px;
  background-color: rgb(198, 212, 248);
  text-align: center;
  font-weight: bold;
  margin: 10px 0;
}
.c-talbe {
  display: table-cell;
  width: 100%;
}

.c-talbe td {
  padding: 5px;
}
p {
  line-height: 24px;
}
</style>
